import React from 'react'
import PropTypes from 'prop-types'
import styles from './overlay.module.scss'

const Overlay = ({ onClose, children, header, hideClose }) => {
  return (
    <div className={`${styles.overlayWrapper}`}>
      <div className={`${styles.overlayInner}`}>
        <div className={`${styles.overlayHeader}`}>
          {header && (
            <h2 className={`${styles.overlayHeaderText}`}>{header}</h2>
          )}
          <span className={`${styles.overlayClose}`} onClick={onClose} />
        </div>
        <div className={`${styles.overlayContent}`}>{children}</div>
      </div>
    </div>
  )
}
Overlay.propTypes = {
  onClose: PropTypes.func.isRequired,
  children: PropTypes.node,
  header: PropTypes.string,
  hideClose: PropTypes.bool,
}
export default Overlay
